/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Payment_Choice_Modal_Pay_Now_DescriptionInputs */

const es_components_payment_choice_modal_pay_now_description = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Now_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagá el mes actual y empezá a usar tu plan inmediatamente.`)
};

const en_components_payment_choice_modal_pay_now_description = /** @type {(inputs: Components_Payment_Choice_Modal_Pay_Now_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay the current month and start using your plan immediately.`)
};

/**
* | output |
* | --- |
* | "Pay the current month and start using your plan immediately." |
*
* @param {Components_Payment_Choice_Modal_Pay_Now_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_payment_choice_modal_pay_now_description = /** @type {((inputs?: Components_Payment_Choice_Modal_Pay_Now_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Payment_Choice_Modal_Pay_Now_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_payment_choice_modal_pay_now_description(inputs)
	return en_components_payment_choice_modal_pay_now_description(inputs)
});
export { components_payment_choice_modal_pay_now_description as "components.payment_choice_modal.pay_now_description" }